const getAgentePayload = () => {
  const rawNew = localStorage.getItem("@claro-lp/agente");

  if (rawNew) {
    try {
      const parsed = JSON.parse(rawNew);

      const agenteId =
        typeof parsed?.matricula === "string" && parsed.matricula.trim()
          ? parsed.matricula.trim()
          : null;

      const usuarioIDNum = Number(parsed?.agenteUsuarioId);
      const usuarioID = Number.isFinite(usuarioIDNum) ? usuarioIDNum : null;

      return {
        ...(agenteId ? { agenteId } : {}),
        ...(usuarioID ? { usuarioID } : {}),
        // ...(parsed?.nome ? { agenteNome: parsed.nome } : {}),
      };
    } catch {
      // cai no legado
    }
  }

  const agenteIdLegacy = localStorage.getItem("@claro-lp/agente-id");
  const usuarioIdLegacyRaw = localStorage.getItem("@claro-lp/agente-usuario-id");
  const usuarioIDNum = Number(usuarioIdLegacyRaw);
  const usuarioID = Number.isFinite(usuarioIDNum) ? usuarioIDNum : null;

  return {
    ...(agenteIdLegacy ? { agenteId: agenteIdLegacy } : {}),
    ...(usuarioID ? { usuarioID } : {}),
  };
};

export {
    getAgentePayload
}
